module.exports = __webpack_public_path__ + "static/UI pattern 1-1f53281a3856d0d678d66e3b1acab5a8.png";